import './ResetPassword.scss'
import React from 'react'
import {withTranslation} from 'react-i18next'
import {Alert, Button, Card, Col, Form, Icon, Input, Row, Spin, Typography} from 'antd'
import {resetPasswordService} from './services/reset-password'

const {Paragraph, Title} = Typography

class ResetPassword extends React.Component {
  state = {
    isValidating: true,
    isTokenValid: false,
    isSaving: false,
    isCompleted: false,
    errorMessage: ''
  }

  componentDidMount() {
    const token = this.getToken()
    if (!token) {
      this.setState({isValidating: false})
      return
    }

    resetPasswordService.validateToken(token)
      .then(response => {
        this.setState({
          isValidating: false,
          isTokenValid: Boolean(response?.data?.valid)
        })
      })
      .catch(() => {
        this.setState({isValidating: false, isTokenValid: false})
      })
  }

  getToken = () => new URLSearchParams(window.location.search).get('token')

  validatePasswordPolicy = (rule, value, callback) => {
    const {t} = this.props
    if (!value) {
      callback()
      return
    }
    if (value.length < 8 || value.length > 30) {
      callback(t('messages.aml.errors.pwd.long.validation'))
      return
    }
    if (!/[A-Z]/.test(value)) {
      callback(t('messages.aml.validation.passwordMustHaveUpperCaseLetter'))
      return
    }
    if (!/[a-z]/.test(value)) {
      callback(t('messages.aml.validation.passwordMustHaveLowerCaseLetter'))
      return
    }
    if (!/[0-9]/.test(value)) {
      callback(t('messages.aml.validation.password.must.be.alphanum'))
      return
    }
    if (!/^[a-zA-Z0-9&*?@#!$%\-_]+$/.test(value)) {
      callback(t('messages.aml.errors.pwd.special.characters'))
      return
    }
    callback()
  }

  comparePasswords = (rule, value, callback) => {
    if (value && value !== this.props.form.getFieldValue('newPassword')) {
      callback(this.props.t('messages.aml.errors.pwd.same.validation'))
      return
    }
    callback()
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.form.validateFields((error, values) => {
      if (error) {
        return
      }

      this.setState({isSaving: true, errorMessage: ''})
      resetPasswordService.resetPassword(
        this.getToken(),
        values.newPassword,
        values.newPasswordConfirm
      ).then(() => {
        this.setState({isSaving: false, isCompleted: true})
      }).catch(errorResponse => {
        const message = errorResponse?.response?.data?.message
          || 'No fue posible cambiar la contraseña.'
        this.setState({isSaving: false, errorMessage: message})
      })
    })
  }

  renderContent() {
    const {getFieldDecorator} = this.props.form
    const {t} = this.props
    const {isTokenValid, isCompleted, isSaving, errorMessage} = this.state

    if (isCompleted) {
      return (
        <>
          <Alert
            type="success"
            showIcon
            message="Contraseña actualizada"
            description="Ya puedes iniciar sesión con tu nueva contraseña."
          />
          <Button type="primary" block onClick={() => { window.location.href = '/' }}>
            Ir al inicio de sesión
          </Button>
        </>
      )
    }

    if (!isTokenValid) {
      return (
        <>
          <Alert
            type="error"
            showIcon
            message="Enlace no válido"
            description="El enlace ya fue utilizado, expiró o fue reemplazado por una solicitud más reciente."
          />
          <Button block onClick={() => { window.location.href = '/' }}>
            Volver al inicio
          </Button>
        </>
      )
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <Paragraph>
          {t('messages.aml.newPasswordMustContain')}: <strong>{t('messages.aml.newPasswordInstructions')}</strong>
        </Paragraph>
        {errorMessage && <Alert type="error" showIcon message={errorMessage}/>}
        <Form.Item>
          {getFieldDecorator('newPassword', {
            rules: [
              {required: true, message: 'Debe ingresar una contraseña.'},
              {validator: this.validatePasswordPolicy}
            ]
          })(
            <Input.Password
              autoComplete="new-password"
              prefix={<Icon type="lock"/>}
              placeholder={t('messages.aml.newPassword')}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('newPasswordConfirm', {
            rules: [
              {required: true, message: 'Debe confirmar la nueva contraseña.'},
              {validator: this.comparePasswords}
            ]
          })(
            <Input.Password
              autoComplete="new-password"
              prefix={<Icon type="lock"/>}
              placeholder={t('messages.aml.newPasswordConfirm')}
            />
          )}
        </Form.Item>
        <Button type="primary" htmlType="submit" block loading={isSaving}>
          Cambiar contraseña
        </Button>
      </Form>
    )
  }

  render() {
    return (
      <div className="reset-password-page">
        <Row type="flex" justify="center" align="middle">
          <Col xs={22} sm={16} md={12} lg={8}>
            <Card className="reset-password-card">
              <Title level={2}>Recuperar contraseña</Title>
              <Spin spinning={this.state.isValidating}>
                {this.state.isValidating ? <div className="reset-password-loading"/> : this.renderContent()}
              </Spin>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const ResetPasswordForm = Form.create({name: 'reset_password'})(ResetPassword)

export default withTranslation()(ResetPasswordForm)
